<template>
  <div class="container">
    <div class="title is-1">Forgot password</div>
    <div class="columns">
      <div class="column is-one-third">
        <b-field label="Email Address">
          <b-input type="email" v-model="Email" placeholder="Email address"></b-input>
        </b-field>
        <br />
        <b-button class="is-primary" v-bind:class="{'is-loading': loading == true}" @click="getPasswordResetLink">Send email with instructions</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'forgotPassword',
    data() {
      return {
        Email: "",
        loading: false
      }
    },
    methods: {
      getPasswordResetLink() {
        this.loading = true;
        this.$http.post("api/user/forgotPassword/" + this.Email)
          .then(resp => {
            if (resp.data == "User Not Found") {
              this.openBadNotification("You must enter a valid User email.");
            } else if (resp.data == "Bad Environment") {
              this.openBadNotification("An unhandled error occurred please try again later.");
            } else if (resp.data == "Invalid Username") {
              this.openBadNotification("Please enter your email in the correct format.");
            }else if (resp.data == "Check your email for the Reset Password Link") {
              this.$buefy.notification.open({
                duration: 4000,
                message: "Please check your email for the link to reset your password",
                type: 'is-success',
              });
            } else {
              this.openBadNotification("An unhandled error occurred please try again later.");
            }
            this.loading = false;
          }).catch(err => {
            this.openBadNotification("An error occurred. Please try again later.");
            this.loading = false;
          })
      },
      openBadNotification(message) {
        this.$buefy.notification.open({
            duration: 4000,
            message: message,
            type: 'is-danger',
          })
      }
    }
  }
</script>
